/**
 * Claves NUEVAS del rediseño del editor V2 (2026-08-01).
 *
 * Van en un módulo aparte (y no en el translations.js de 4700 líneas) para no
 * tener que editar el mismo archivo gigante en tres lugares cada vez. Se
 * mergean DESPUÉS de `translations`, así que lo de acá PISA a lo de allá: es
 * el lugar para redefinir un texto viejo que el rediseño cambió.
 */
const editorV2 = {
  es: {
    // ─── Shell ───
    "editor.save": "Subir menú",
    "editor.saveMobile": "Subir",
    "editor.saving": "Subiendo…",
    "editor.unsaved": "Cambios sin subir",
    "editor.published": "Publicado",
    "editor.unsavedHint": "Tocá “Subir” para que los vean tus clientes",
    "editor.discard": "Descartar",
    "editor.discardTitle": "¿Descartar los cambios?",
    "editor.discardMsg": "Se pierde todo lo que editaste desde la última vez que subiste el menú y vuelve a como está publicado ahora.",
    "editor.discardConfirm": "Sí, descartar",
    "editor.discardCancel": "Seguir editando",
    "nav.sections": "Secciones",
    "nav.settings": "Ajustes",
    "nav.settingsShort": "Ajustes",
    "nav.modules": "Promos",
    "nav.modulesShort": "Promos",

    // ─── Ajustes ───
    "settings.title": "Ajustes del menú",
    "settings.desc": "Idiomas, moneda, horarios y datos de contacto de tu local.",
    "general.defaultLangHint": "Es el idioma que ven tus clientes al abrir la carta.",
    "general.noExtraLangs": "Sin idiomas adicionales. La carta se muestra solo en el idioma principal.",
    "general.currencyHint": "Todos los precios del menú se muestran con {symbol}.",
    "general.addLangSub": "Elegí el idioma a agregar",
    "info.socialDesc": "Los links que aparecen al pie de tu carta.",
    "info.wifiDesc": "Mostrar la red y la clave del WiFi en la carta.",
    "info.hoursDesc": "Los horarios que ven tus clientes. Podés cargar más de un turno por día.",

    // ─── Catálogo ───
    // ─── Textos heredados que traían el ícono ADENTRO ("+ Producto",
    //     "👁️ Vista previa"): el rediseño ya pone el ícono aparte y salía repetido.
    "catalog.addProduct": "Producto",
    "catalog.addSubcategory": "Sub-categoría",
    "catalog.createFirst": "Crear la primera categoría",
    "info.addRange": "Agregar franja",
    "category.addRange": "Agregar franja",
    "modules.annAddRange": "Agregar franja",
    "modules.createCustom": "Crear plato suelto",
    "modules.addFromCatalog": "Agregar del catálogo",
    "modules.annPreview": "Vista previa del anuncio",
    "general.addLang": "Agregar idioma",
    "category.priceTypesAdd": "Agregar tipo de precio",

    "catalog.search": "Buscar plato o categoría…",
    "catalog.searchClear": "Limpiar búsqueda",
    "catalog.noResults": "Sin resultados",
    "catalog.noResultsFor": "No encontramos nada con “{term}”.",
    "catalog.newCategory": "Categoría",
    "catalog.countCategories": "{n} categorías",
    "catalog.countProducts": "{n} platos",
    "catalog.countMatches": "{n} con resultados",
    "catalog.expandAll": "Abrir todas",
    "catalog.collapseAll": "Cerrar todas",
    "catalog.expand": "Abrir",
    "catalog.collapse": "Cerrar",
    "catalog.more": "Más opciones",
    "catalog.emptyDesc": "Creá tu primera categoría (Entradas, Principales, Bebidas…) y empezá a cargar platos.",
    "catalog.addFirstProduct": "Agregar el primer plato",
    "catalog.noPrice": "Sin precio",
    "catalog.hidden": "Oculta",
    "catalog.hiddenInMenu": "Oculto en la carta",
    "catalog.editCategory": "Editar categoría",
    "catalog.deleteCategory": "Eliminar categoría",
    "catalog.showCategory": "Mostrar en la carta",
    "catalog.hideCategory": "Ocultar de la carta",
    "catalog.hiddenSub": "Ahora no la ven tus clientes",
    "catalog.visibleSub": "Ahora la ven tus clientes",
    "catalog.editProduct": "Editar plato",
    "catalog.hideProductSub": "Deja de verse en la carta",
    "catalog.showProductSub": "Vuelve a verse en la carta",
    "catalog.deleteProductNamed": "Se va a eliminar “{name}”. No se puede deshacer.",
    "catalog.priceSave": "Guardar precio",
    "catalog.priceCancel": "Cancelar",
    "catalog.bulkSheetSub": "Subir o bajar todos los precios de una",
    "catalog.bulkPercent": "Porcentaje",
    "catalog.bulkFixed": "Monto fijo",
    "catalog.bulkPercentLabel": "Cuánto subir o bajar (%)",
    "catalog.bulkFixedLabel": "Cuánto sumar o restar ({symbol})",
    "catalog.bulkHint": "Poné un número negativo para bajar los precios.",
    "catalog.bulkPreview": "Cómo queda",
    "catalog.bulkAffects": "Afecta a {n} platos con precio cargado.",
    "catalog.bulkNoPrices": "Esta categoría todavía no tiene platos con precio.",
    "catalog.bulkNegative": "Con ese valor algún precio queda negativo. Ajustalo antes de aplicar.",
    "catalog.bulkZeroed": "Ojo: con ese valor algún plato queda en $0.",

    // ─── Modales ───
    "catalog.moveTop": "Mover al principio",
    "catalog.moveUp": "Subir una posición",
    "catalog.moveDown": "Bajar una posición",
    "product.langsMissing": "Falta el nombre en {langs}. Si lo dejás vacío, el plato aparece sin nombre para quien mira la carta en ese idioma.",
    "category.langsMissing": "Falta el nombre en {langs}. Si lo dejás vacío, la categoría aparece sin nombre en ese idioma.",
    "product.langsOk": "Traducido a {langs}.",
    "product.langsWriteThem": "Escribirlos yo",
    "product.langsConfirmTitle": "Te faltan idiomas",
    "product.langsConfirmMsg": "Todavía no cargaste el nombre en {langs}. ¿Lo traducimos ahora?",
    "category.langsConfirmMsg": "Todavía no cargaste el nombre de la categoría en {langs}. ¿Lo traducimos ahora?",
    "product.langsConfirmTranslate": "Traducir y guardar",
    "product.langsConfirmSkip": "Guardar igual",
    "conflict.title": "Este menú cambió en otro lado",
    "conflict.msg": "Alguien modificó y subió este menú desde otro dispositivo o pestaña después de que vos abriste el editor. Si subís ahora, pisás esos cambios; si los traés, se descarta lo que editaste acá.",
    "conflict.overwrite": "Subir igual (pisar)",
    "conflict.reload": "Traer los cambios",
    "conflict.reloadWarn": "Traer los cambios descarta lo que editaste acá.",
    "conflict.reloaded": "Se actualizó con los cambios de otro dispositivo",
    "conflict.banner": "Este menú cambió en otro dispositivo",
    "conflict.bannerHint": "Si subís, pisás lo de allá; si los traés, perdés lo que editaste acá.",
    "product.category": "Categoría",
    "product.categoryHint": "Cambiala para mover el plato a otra categoría.",
    "product.discardTitle": "¿Descartar los cambios?",
    "product.discardMsg": "Editaste cosas que todavía no guardaste. Si salís ahora se pierden.",
    "product.discardConfirm": "Descartar",
    "product.discardCancel": "Seguir editando",
    "product.translateFailed": "No se pudo traducir. Probá de nuevo en un minuto.",
    "product.translatedOk": "Traducciones listas",
    "category.scheduleOn": "Activa",
    "category.scheduleOff": "Sin límite",
  },

  en: {
    "editor.save": "Publish menu",
    "editor.saveMobile": "Publish",
    "editor.saving": "Publishing…",
    "editor.unsaved": "Unpublished changes",
    "editor.published": "Published",
    "editor.unsavedHint": "Tap “Publish” so your guests can see them",
    "editor.discard": "Discard",
    "editor.discardTitle": "Discard the changes?",
    "editor.discardMsg": "Everything you edited since you last published is lost and the menu goes back to what's published right now.",
    "editor.discardConfirm": "Yes, discard",
    "editor.discardCancel": "Keep editing",
    "nav.sections": "Sections",
    "nav.settings": "Settings",
    "nav.settingsShort": "Settings",
    "nav.modules": "Promos",
    "nav.modulesShort": "Promos",

    "settings.title": "Menu settings",
    "settings.desc": "Languages, currency, opening hours and contact details.",
    "general.defaultLangHint": "This is the language guests see when they open the menu.",
    "general.noExtraLangs": "No extra languages. The menu shows only in the main language.",
    "general.currencyHint": "All menu prices are shown with {symbol}.",
    "general.addLangSub": "Pick a language to add",
    "info.socialDesc": "The links shown at the bottom of your menu.",
    "info.wifiDesc": "Show the WiFi network and password on the menu.",
    "info.hoursDesc": "The hours your guests see. You can add more than one shift per day.",

    // Legacy labels that carried the icon inline — the redesign renders it separately.
    "catalog.addProduct": "Dish",
    "catalog.addSubcategory": "Sub-category",
    "catalog.createFirst": "Create the first category",
    "info.addRange": "Add time slot",
    "category.addRange": "Add time slot",
    "modules.annAddRange": "Add time slot",
    "modules.createCustom": "Create a one-off dish",
    "modules.addFromCatalog": "Add from catalog",
    "modules.annPreview": "Announcement preview",
    "general.addLang": "Add language",
    "category.priceTypesAdd": "Add price type",

    "catalog.search": "Search dish or category…",
    "catalog.searchClear": "Clear search",
    "catalog.noResults": "No results",
    "catalog.noResultsFor": "Nothing found for “{term}”.",
    "catalog.newCategory": "Category",
    "catalog.countCategories": "{n} categories",
    "catalog.countProducts": "{n} dishes",
    "catalog.countMatches": "{n} with results",
    "catalog.expandAll": "Expand all",
    "catalog.collapseAll": "Collapse all",
    "catalog.expand": "Expand",
    "catalog.collapse": "Collapse",
    "catalog.more": "More options",
    "catalog.emptyDesc": "Create your first category (Starters, Mains, Drinks…) and start adding dishes.",
    "catalog.addFirstProduct": "Add the first dish",
    "catalog.noPrice": "No price",
    "catalog.hidden": "Hidden",
    "catalog.hiddenInMenu": "Hidden from the menu",
    "catalog.editCategory": "Edit category",
    "catalog.deleteCategory": "Delete category",
    "catalog.showCategory": "Show on the menu",
    "catalog.hideCategory": "Hide from the menu",
    "catalog.hiddenSub": "Guests can't see it now",
    "catalog.visibleSub": "Guests can see it now",
    "catalog.editProduct": "Edit dish",
    "catalog.hideProductSub": "Stops showing on the menu",
    "catalog.showProductSub": "Shows on the menu again",
    "catalog.deleteProductNamed": "“{name}” will be deleted. This can't be undone.",
    "catalog.priceSave": "Save price",
    "catalog.priceCancel": "Cancel",
    "catalog.bulkSheetSub": "Raise or lower every price at once",
    "catalog.bulkPercent": "Percentage",
    "catalog.bulkFixed": "Fixed amount",
    "catalog.bulkPercentLabel": "How much to raise or lower (%)",
    "catalog.bulkFixedLabel": "How much to add or subtract ({symbol})",
    "catalog.bulkHint": "Use a negative number to lower prices.",
    "catalog.bulkPreview": "Preview",
    "catalog.bulkAffects": "Affects {n} dishes that have a price.",
    "catalog.bulkNoPrices": "This category has no priced dishes yet.",
    "catalog.bulkNegative": "That value makes some price negative. Adjust it before applying.",
    "catalog.bulkZeroed": "Heads up: that value leaves some dish at 0.",

    "catalog.moveTop": "Move to the top",
    "catalog.moveUp": "Move up",
    "catalog.moveDown": "Move down",
    "product.langsMissing": "The name in {langs} is missing. Left empty, the dish shows with no name to guests reading the menu in that language.",
    "category.langsMissing": "The name in {langs} is missing. Left empty, the category shows with no name in that language.",
    "product.langsOk": "Translated to {langs}.",
    "product.langsWriteThem": "I'll write them",
    "product.langsConfirmTitle": "Missing languages",
    "product.langsConfirmMsg": "You haven't set the name in {langs}. Translate it now?",
    "category.langsConfirmMsg": "You haven't set the category name in {langs}. Translate it now?",
    "product.langsConfirmTranslate": "Translate and save",
    "product.langsConfirmSkip": "Save anyway",
    "conflict.title": "This menu changed somewhere else",
    "conflict.msg": "Someone edited and published this menu from another device or tab after you opened the editor. Publishing overwrites those changes; bringing them in discards what you edited here.",
    "conflict.overwrite": "Publish anyway (overwrite)",
    "conflict.reload": "Bring those changes",
    "conflict.reloadWarn": "Bringing those changes discards what you edited here.",
    "conflict.reloaded": "Updated with changes from another device",
    "conflict.banner": "This menu changed on another device",
    "conflict.bannerHint": "Publishing overwrites theirs; bringing them in discards yours.",
    "product.category": "Category",
    "product.categoryHint": "Change it to move the dish to another category.",
    "product.discardTitle": "Discard changes?",
    "product.discardMsg": "You have unsaved edits. If you leave now they're lost.",
    "product.discardConfirm": "Discard",
    "product.discardCancel": "Keep editing",
    "product.translateFailed": "Could not translate. Try again in a minute.",
    "product.translatedOk": "Translations ready",
    "category.scheduleOn": "Active",
    "category.scheduleOff": "No limit",
  },

  pt: {
    "editor.save": "Publicar menu",
    "editor.saveMobile": "Publicar",
    "editor.saving": "Publicando…",
    "editor.unsaved": "Alterações não publicadas",
    "editor.published": "Publicado",
    "editor.unsavedHint": "Toque em “Publicar” para que seus clientes vejam",
    "editor.discard": "Descartar",
    "editor.discardTitle": "Descartar as alterações?",
    "editor.discardMsg": "Perde tudo o que editou desde a última publicação e volta ao que está publicado agora.",
    "editor.discardConfirm": "Sim, descartar",
    "editor.discardCancel": "Continuar editando",
    "nav.sections": "Seções",
    "nav.settings": "Ajustes",
    "nav.settingsShort": "Ajustes",
    "nav.modules": "Promos",
    "nav.modulesShort": "Promos",

    "settings.title": "Ajustes do menu",
    "settings.desc": "Idiomas, moeda, horários e dados de contato do seu local.",
    "general.defaultLangHint": "É o idioma que seus clientes veem ao abrir o cardápio.",
    "general.noExtraLangs": "Sem idiomas adicionais. O cardápio aparece só no idioma principal.",
    "general.currencyHint": "Todos os preços do menu aparecem com {symbol}.",
    "general.addLangSub": "Escolha o idioma para adicionar",
    "info.socialDesc": "Os links que aparecem no rodapé do seu cardápio.",
    "info.wifiDesc": "Mostrar a rede e a senha do WiFi no cardápio.",
    "info.hoursDesc": "Os horários que seus clientes veem. Você pode ter mais de um turno por dia.",

    // Textos herdados que traziam o ícone dentro — o redesenho já o coloca à parte.
    "catalog.addProduct": "Prato",
    "catalog.addSubcategory": "Subcategoria",
    "catalog.createFirst": "Criar a primeira categoria",
    "info.addRange": "Adicionar faixa",
    "category.addRange": "Adicionar faixa",
    "modules.annAddRange": "Adicionar faixa",
    "modules.createCustom": "Criar prato avulso",
    "modules.addFromCatalog": "Adicionar do catálogo",
    "modules.annPreview": "Pré-visualizar o anúncio",
    "general.addLang": "Adicionar idioma",
    "category.priceTypesAdd": "Adicionar tipo de preço",

    "catalog.search": "Buscar prato ou categoria…",
    "catalog.searchClear": "Limpar busca",
    "catalog.noResults": "Sem resultados",
    "catalog.noResultsFor": "Não encontramos nada com “{term}”.",
    "catalog.newCategory": "Categoria",
    "catalog.countCategories": "{n} categorias",
    "catalog.countProducts": "{n} pratos",
    "catalog.countMatches": "{n} com resultados",
    "catalog.expandAll": "Abrir todas",
    "catalog.collapseAll": "Fechar todas",
    "catalog.expand": "Abrir",
    "catalog.collapse": "Fechar",
    "catalog.more": "Mais opções",
    "catalog.emptyDesc": "Crie sua primeira categoria (Entradas, Principais, Bebidas…) e comece a adicionar pratos.",
    "catalog.addFirstProduct": "Adicionar o primeiro prato",
    "catalog.noPrice": "Sem preço",
    "catalog.hidden": "Oculta",
    "catalog.hiddenInMenu": "Oculto no cardápio",
    "catalog.editCategory": "Editar categoria",
    "catalog.deleteCategory": "Excluir categoria",
    "catalog.showCategory": "Mostrar no cardápio",
    "catalog.hideCategory": "Ocultar do cardápio",
    "catalog.hiddenSub": "Seus clientes não veem agora",
    "catalog.visibleSub": "Seus clientes veem agora",
    "catalog.editProduct": "Editar prato",
    "catalog.hideProductSub": "Deixa de aparecer no cardápio",
    "catalog.showProductSub": "Volta a aparecer no cardápio",
    "catalog.deleteProductNamed": "“{name}” será excluído. Não dá para desfazer.",
    "catalog.priceSave": "Salvar preço",
    "catalog.priceCancel": "Cancelar",
    "catalog.bulkSheetSub": "Subir ou baixar todos os preços de uma vez",
    "catalog.bulkPercent": "Porcentagem",
    "catalog.bulkFixed": "Valor fixo",
    "catalog.bulkPercentLabel": "Quanto subir ou baixar (%)",
    "catalog.bulkFixedLabel": "Quanto somar ou subtrair ({symbol})",
    "catalog.bulkHint": "Use um número negativo para baixar os preços.",
    "catalog.bulkPreview": "Como fica",
    "catalog.bulkAffects": "Afeta {n} pratos com preço.",
    "catalog.bulkNoPrices": "Esta categoria ainda não tem pratos com preço.",
    "catalog.bulkNegative": "Com esse valor algum preço fica negativo. Ajuste antes de aplicar.",
    "catalog.bulkZeroed": "Atenção: com esse valor algum prato fica em 0.",

    "catalog.moveTop": "Mover para o início",
    "catalog.moveUp": "Subir uma posição",
    "catalog.moveDown": "Descer uma posição",
    "product.langsMissing": "Falta o nome em {langs}. Vazio, o prato aparece sem nome para quem vê o cardápio nesse idioma.",
    "category.langsMissing": "Falta o nome em {langs}. Vazio, a categoria aparece sem nome nesse idioma.",
    "product.langsOk": "Traduzido para {langs}.",
    "product.langsWriteThem": "Escrevo eu",
    "product.langsConfirmTitle": "Faltam idiomas",
    "product.langsConfirmMsg": "Você ainda não colocou o nome em {langs}. Traduzimos agora?",
    "category.langsConfirmMsg": "Você ainda não colocou o nome da categoria em {langs}. Traduzimos agora?",
    "product.langsConfirmTranslate": "Traduzir e salvar",
    "product.langsConfirmSkip": "Salvar assim mesmo",
    "conflict.title": "Este menu mudou em outro lugar",
    "conflict.msg": "Alguém editou e publicou este menu de outro dispositivo ou aba depois que você abriu o editor. Publicar sobrescreve essas alterações; trazê-las descarta o que você editou aqui.",
    "conflict.overwrite": "Publicar mesmo assim",
    "conflict.reload": "Trazer as alterações",
    "conflict.reloadWarn": "Trazer as alterações descarta o que você editou aqui.",
    "conflict.reloaded": "Atualizado com as alterações de outro dispositivo",
    "conflict.banner": "Este menu mudou em outro dispositivo",
    "conflict.bannerHint": "Publicar sobrescreve o deles; trazê-las descarta o seu.",
    "product.category": "Categoria",
    "product.categoryHint": "Mude para mover o prato para outra categoria.",
    "product.discardTitle": "Descartar as alterações?",
    "product.discardMsg": "Você tem edições não salvas. Se sair agora, elas se perdem.",
    "product.discardConfirm": "Descartar",
    "product.discardCancel": "Continuar editando",
    "product.translateFailed": "Não foi possível traduzir. Tente de novo em um minuto.",
    "product.translatedOk": "Traduções prontas",
    "category.scheduleOn": "Ativa",
    "category.scheduleOff": "Sem limite",
  },
};

export default editorV2;
